<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Promoters | Visualizar" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-affiliate :affiliate="affiliate" readonly />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import AffiliateService from '@/services/AffiliateService'
import type Affiliate from '@/types/Affiliate'
import FormAffiliate from './form-affiliate.vue'

export default defineComponent({
  components: {
    TPageTitle,
    FormAffiliate,
  },
  data() {
    return {
      affiliate: {
        name: '',
        email: '',
        tag: '',
        observation: '',
      } as Affiliate,
      resource: 'affiliates',
    }
  },
  computed: {},
  mounted() {
    this.fetch()
  },
  methods: {
    async fetch() {
      try {
        this.$loader.increment()
        const response = await new AffiliateService().show(
          this.$route.params.id as string,
        )
        this.affiliate = response.data.data
      } catch (error) {
        this.$snackbar.show('Não foi possível buscar o promoter', 'error')

        throw error
      } finally {
        this.$loader.decrement()
      }
    },
  },
})
</script>
